import React from "react";
import { Loading } from "seed/helpers";
import SchemaFormView from "components/util/schema_form/SchemaForm.view";


const SmartTextView = ({
  schema,
  schemaValues,
  flowId,
  nodeId,
  isLoading,
  onClickSubmit
}) => (
  <div>
    {isLoading ?
      <Loading size={24} />
      :
      <SchemaFormView
        schema={schema}
        initialValues={schemaValues}
        submitText={"Enviar"}
        flowId={flowId}
        nodeId={nodeId}
        submitComponent={({ values }) => <button className="btn btn-block btn-primary font-weight-bold" type="button" onClick={() => onClickSubmit(values)}>Enviar</button>}
        onSubmit={onClickSubmit}
      />
    }
  </div>
)


export default SmartTextView;